import type { Xinglet } from '@xing-com/crate-xinglet';

import { App } from './app';

export default class CompaniesFrontend implements Xinglet {
  public getComponent() {
    return (): JSX.Element => <App />;
  }
}
